export default "__VITE_ASSET__Nzx_rYrp__"